<template>
  <validation-observer v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(handleAddLimit)" class="limits-form">
      <p class="title">{{ $t("portfolioManager.poolSidebar.setLimits") }}</p>
      <validation-provider
        v-slot="{ failed, errors }"
        rules="required"
        name="rule"
      >
        <select-box
          :hasError="failed"
          :helperText="errors[0]"
          label="name"
          :name="$t('portfolioManager.poolSidebar.rule')"
          v-model="rule"
          :options="ruleOptions"
          :clearable="false"
        />
      </validation-provider>
      <div class="combo-input" v-if="rule.value !== 'tickers'">
        <validation-provider
          v-slot="{ failed, errors }"
          class="limit-input"
          rules="required"
        >
          <select-box
            :hasError="failed"
            :helperText="errors[0]"
            name="Limit"
            label="name"
            :options="limitOptions"
            v-model="limit"
            :clearable="false"
          />
        </validation-provider>
        <validation-provider
          v-slot="{ failed, errors }"
          class="weight-input"
          rules="required|maxPercentage"
        >
          <simple-form-input
            :hasError="failed"
            :helperText="errors[0]"
            :label="$t('portfolioManager.poolSidebar.value')"
            v-model="value"
            type="number"
            step="0.01"
            hideTrailingIconUnfocused
          >
            <template slot="trailingIcon" v-if="rule.value === 'weight'">
              %
            </template>
          </simple-form-input>
        </validation-provider>
      </div>
      <div v-else>
        <validation-provider  v-slot="{ failed, errors }">
          <select-box
            :hasError="failed"
            :helperText="errors[0]"
            name="Stocks"
            label="ticker"
            :options="tickersList"
            v-model="tickers"
            :clearable="false"
            :formatOption="true"
            :multiple="true"
          />
        </validation-provider>
      </div>
      <b-button class="w-100 justify-content-center" type="submit">
        {{ $t("portfolioManager.poolSidebar.applyNewLimit") }}
      </b-button>
    </form>
  </validation-observer>
</template>

<script>
import {
  LIMIT_OPTIONS,
  MAX,
  RULE_OPTIONS,
} from "../../utils/constants";
import SelectBox from "../inputs/SelectBox.vue";
import SimpleFormInput from "../inputs/SimpleFormInput.vue";
import { composeTickerRuleList } from '../../utils/helper';
import { mapGetters } from "vuex";
export default {
  components: { SelectBox, SimpleFormInput },
  name: "limits-form",
  data() {
    return {
      value: null,
      ruleOptions: RULE_OPTIONS(),
      rule: RULE_OPTIONS()[0],
      limit: null,
      tickers: null,
    };
  },
  methods: {
    handleAddLimit() {
      if(this.rule.value === "tickers"){
       this. tickers.forEach(element => {
        this.$emit("ruleAdded", {
          value: element,
          rule: this.rule,
          });
        });
      }
      else{
        this.$emit("ruleAdded", {
        value: parseFloat(this.value),
        rule: this.rule,
        limit: this.limit,
      });
      }
      this.tickers = [];
    },
  },
  computed: {
    ...mapGetters("portfolioManagerStore", ["selectedPool", "rules", "removedTickers", "portfolio"]),
    limitOptions() {
      const limits = LIMIT_OPTIONS();
      return this.rule.value === "weight"
        ? limits
        : limits.filter((lim) => lim.value === MAX);
    },
    tickersList(){
      const blocked = composeTickerRuleList(this.rules);
      const blockedCustom = this.removedTickers.length !== 0
        ? this.portfolio.portfolio_input.custom_portfolio.map(({ ticker }) => ticker)
        : [];
      const tickers = blocked.concat(blockedCustom);
      return tickers.length 
        ? this.selectedPool.tickers.filter(item => !tickers.includes(item.ticker))
        : this.selectedPool.tickers;
    }
  },
  watch: {
    rule(newValue) {
      if (newValue.value === "count") {
        this.limit = LIMIT_OPTIONS()[1];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.limits-form {
  .combo-input {
    display: flex;
    justify-content: space-between;
    .limit-input {
      width: calc(100% - 72px);
    }
    .weight-input {
      width: toRem(68);
    }
  }
  .title {
    margin-bottom: 1rem;
    font-size: $s-font;
    font-weight: 500;
    color: $headingsColor;
  }
}
</style>